import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'site-modules/shared/components/link/link';
import { AnimatedSticky } from 'site-modules/shared/components/animated-sticky/animated-sticky';

const LINKS_MAP = [
  { href: '/research/', title: 'Research' },
  { href: '/car-buying/', title: 'Buying' },
  { href: '/car-leasing/', title: 'Leasing' },
  { href: '/sell-car/', title: 'Sell my car' },
  { href: '/car-news/', title: 'News' },
  { href: '/car-maintenance/', title: 'Maintenance' },
  { href: '/auto-insurance/', title: 'Auto Insurance' },
  { href: '/car-safety/', title: 'Safety' },
  { href: '/fuel-economy/', title: 'Fuel Economy' },
  { href: '/driving-tips/', title: 'Driving Tips' },
  { href: '/car-technology/', title: 'Technology' },
  { href: '/how-to/', title: 'How To' },
  { href: '/car-loan/', title: 'Car Loan' },
];

export function MoreInCategoryLink({ className, categorySlug }) {
  const currentLink = LINKS_MAP.find(({ href }) => href.includes(categorySlug));
  if (!currentLink) {
    return null;
  }

  return (
    <AnimatedSticky identifierClass="sticky-more-about-link" className={className}>
      <Link className="d-inline-block py-1" to={currentLink.href}>
        More in {currentLink.title}
        <i className="d-inline-block ms-0_25 text-primary-darker icon-arrow-right4 size-10" aria-hidden />
      </Link>
    </AnimatedSticky>
  );
}

MoreInCategoryLink.propTypes = {
  categorySlug: PropTypes.string.isRequired,
  className: PropTypes.string,
};

MoreInCategoryLink.defaultProps = {
  className: null,
};
